import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOmniaVideo, getOmniaVideo, getOmniaVideoItems } from '../../redux/videos';
import { SEO } from '../seo/seo';
import { OmniaVideoPage } from './omnia_video_page_container';

interface OwnProps {
  slug: string;
}

export const OmniaVideoPageLoader = (props: OwnProps) => {
  const { slug } = props;
  const dispatch = useDispatch();
  const omnia_video = useSelector(getOmniaVideo);
  const omnia_video_items = useSelector(getOmniaVideoItems);

  useFrontload(`OmniaVideoPageLoader_${slug}`, async () => {
    await dispatch(fetchOmniaVideo(slug));

    return true;
  });

  if (!omnia_video) {
    return null;
  }

  const videoItems = omnia_video.livestream
    ? omnia_video_items.slice().reverse()
    : omnia_video_items;

  const { title, summary } = omnia_video;
  return (
    <>
      <SEO title={title} description={summary} />
      <OmniaVideoPage omnia_video={omnia_video} omnia_video_items={videoItems} />
    </>
  );
};
